import { useAuthSelector } from '@providers/AuthProvider/ui/AuthProvider';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import { routes } from '@shared/constants/paths';
import AuthWrapper from '@components/AuthWrapper';
import PageTransition from '@components/PageTransition/ui/PageTransition';

/**
 * @description Component as layout for all Authorization pages (SignIn, SignUp, ForgotPassword)
 */

function AuthLayout() {
  const userData = useAuthSelector((state) => state.userData);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (userData) {
      navigate(routes.home);
    }
  }, [userData]);

  // Safety net for scroll-lock left behind by dialogs/modals during auth flows.
  useEffect(() => {
    const cleanup = () => {
      const hasMuiModal = !!document.querySelector('.MuiModal-root');
      const modalRoot = document.getElementById('modalRoot');
      const hasPortalModal = !!modalRoot && modalRoot.childElementCount > 0;
      if (hasMuiModal || hasPortalModal) return;

      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      document.documentElement.style.overflow = '';
    };

    const t = window.setTimeout(cleanup, 0);
    return () => window.clearTimeout(t);
  }, [location.pathname]);

  return (
    <AuthWrapper>
      <PageTransition />
      <Toaster position="top-right" />
    </AuthWrapper>
  );
}

export default AuthLayout;
